import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/nav/nav_1.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/faq-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/form-result.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/google-play-btn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/hero-result.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/job-result-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/LocalStorageVersionCheck.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/modal-email-sent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/projection-radar-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/projection-rapport.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/projection-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/quiz-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/common/otherComponents/student-result.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1650872563/src/minisite-iovia/components/faq/faq_1.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/CTA-bg.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/CTA.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/error.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/feature.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/feature2-1.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/feature2-2.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/feature2-3.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/feature2-4.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/feature4.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/ficher-metier/data.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/hero-2.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/hero.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/ico2.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/landing.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/logo.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1650872563/src/minisite-iovia/public/results.webp");
